import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Globals } from 'src/app/common/globals';

@Injectable({
  providedIn: 'root',
})
export class RolePermissionGuard {
  constructor(private globals: Globals, private router: Router) { }

  professionalRoutes = [
    '',
    'create-account',
    'credential-registry',
    'forgot-password',
    'profile',
    'payment-history',
    'application-terms-conditions',
    'settings',
    'professional',
    'my-activities',
    'facility',
    'tickets',
    'store'
  ];

  candidateRoutes = ['professional', 'my-activities', 'store'];

  adminOnlyRoutes = [
    'manage',
  ];

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.globals.authData) {
      if (
        this.globals.isCandidate &&
        !this.globals.isItAdmin &&
        !this.globals.isAdmin &&
        !this.globals.isAuditor &&
        !this.globals.isCredentialManager &&
        !this.globals.isAccountant &&
        !this.globals.isFacility
      ) {
        if (
          this.professionalRoutes.includes(
            this.globals.currentLink.split('/')[1]
          )
        ) {
          return true;
        } else {
          this.router.navigate(['/professional']);
          return false;
        }
      } else {
        if (
          this.candidateRoutes.includes(
            this.globals.currentLink.split('/')[1]
          )
        ) {
          if (this.globals.isItAdmin || this.globals.isAdmin) {
            this.router.navigate(['/my-admin/dashboard']);
            return false;
          } else {
            this.router.navigate(['/my-admin']);
            return false;
          }
        } else if ((this.globals.isAuditor || this.globals.isAccountant) && (this.adminOnlyRoutes.includes(this.globals.currentLink.split('/')[1]) || this.globals.currentLink.split('/')[2] == 'dashboard')) {
          this.router.navigate(['/my-admin/audit']);
          return false;
        }
         else if ((!this.globals.isItAdmin) && this.globals.currentLink.split('/')[2] == 'add-release-notes') {
          this.router.navigate(['/my-admin/dashboard']);
          return false;
        } 
         else if ((this.globals.isFacility) && this.globals.currentLink.split('/')[1] == 'my-admin') {
          this.router.navigate(['/facility']);
          return false;
        } else if ((this.globals.isCredentialManager) && (this.adminOnlyRoutes.includes(this.globals.currentLink.split('/')[1]) || this.globals.currentLink.split('/')[2] == 'audit')) {
          this.router.navigate(['/my-admin/users']);
          return false;
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  }
}
